module.exports = __webpack_public_path__ + "static/media/news-wmhd-10-2022.2f6b4c59.jpg";